import { ModelTypes } from '@/typings/types/types';
import { ActionContext, ActionTree } from 'vuex';
import { ClipboardState } from '@/store/modules/clipboard/state';
import { RootState } from '@/store/state';

type ClipboardActionContext = ActionContext<ClipboardState, RootState>;

export type Actions = {
  addToClipboard(context: ClipboardActionContext, model: ModelTypes): void;
  onResetClipboard(context: ClipboardActionContext): void;
};

export const actions: ActionTree<ClipboardState, RootState> & Actions = {
  addToClipboard: ({ commit }, model) => {
    commit('addModelToClipboard', model);
    commit('addDataToClipboard', model.serialize());
  },
  onResetClipboard: ({ commit }) => {
    commit('removeElementFromClipboard');
  }
};
